import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
    selector: 'medsurf-control-redirect',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './redirect.control.component.html',
    styleUrls: ['./redirect.control.component.css'],
    standalone: false
})
export class RedirectControlComponent{

}
